import request from "@/utils/request";
import qs from 'qs';
//获取查询列表
export const getRoleDetail = (date) => {
  return request({
    url: "/api/mp/template/getList",
    method: "GET",
    date
  })
}
//修改头部尾部文案
export const postRoleDetail = (data) => {
  return request({
    url: "/api/mp/template/update",
    method: "POST",
    data: qs.stringify(data),
  })
}
//短信查询列表
export const Demandquery = (date) => {
  return request({
    url: "/api/smsTemplate/list",
    method: "GET",
    params: date
  })
}
//短信修改功能
export const getDemandquery = (date) => {
  return request({
    url: "/api/smsTemplate/update",
    method: "POST",
    data: qs.stringify(date)
  })
}

//app小程序数据接口
export const postqueryList = (date) => {
  return request({
    url: "/api/auth/appid/queryList",
    method: "POST",
    params: date
  })
}
//微信启用状态
export const Shutdownenable = (date) => {
  return request({
    url: "/api/mp/template/enable",
    method: "POST",
    params: date
  })
}
//微信关闭状态
export const Setruresy = (date) => {
  return request({
    url: "/api/mp/template/disable",
    method: "POST",
    params: date
  })
}
export const Smastatus = (date) => {
  return request({
    url: "/api/smsTemplate/updateState",
    method: "POST",
    params: date
  })
}

